// extracted by mini-css-extract-plugin
export default {"incorrectBirth":"SignUpIncorrectBirthStep_incorrectBirth__iZU51Nzr","warning":"SignUpIncorrectBirthStep_warning__O+8RJhE0","back":"SignUpIncorrectBirthStep_back__T3NaVOv0"};